export default function Contacts({context}) {
    return(<>
        <h2>{context.contacts}</h2>
        <div><a href="https://t.me/carfaxua" target="_blank">https://t.me/carfaxua</a></div>
        <div><a href="https://t.me/carfaxshara" target="_blank">https://t.me/carfaxshara</a></div>
    </>)
}